import { GET_RISK_ASSESSMENT_REQUEST } from "../types/riskAssessmentTypes";

const initialState = {
  user_choice: "",
  hypotheses: [],
  loading: false,
  error: null,
};

const riskAssessmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RISK_ASSESSMENT_REQUEST:
      return {
        ...state,
        user_choice: action?.payload?.user_choice || "",
        hypotheses: Array.isArray(action?.payload?.hypotheses)
          ? action.payload.hypotheses
          : [],
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export default riskAssessmentReducer;
